import { MediaLibraryEssence } from '@/types/mediaLibrary'
import { Mutation } from 'vuex'
import { MediaLibraryState } from '../types'

const clearMediaLibrary: Mutation<MediaLibraryState> = (
  state,
  essence: MediaLibraryEssence
) => {
  const mediaLibrary = new Map(state.value)

  mediaLibrary.get(essence)?.images.forEach((image) => {
    if (image.image?.url.startsWith('blob:')) {
      window.URL.revokeObjectURL(image.image.url)
    }

    if (image.preview?.startsWith('blob:')) {
      window.URL.revokeObjectURL(image.preview)
    }
  })

  mediaLibrary.delete(essence)
  state.value = mediaLibrary
}

export default clearMediaLibrary
